import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const CustomThemeTemplate = htmlE`
  <section id="customTheme">
    <a
      class="learn-more"
      target="_blank"
      href="https://www.crushftp.com/crush11wiki/Wiki.jsp?page=Custom%20Theme">
      <span data-i18n-key="learnMore">Learn more</span>
      ...
    </a>
    <form class="list-table">
      <table class="table is-fullwidth bg-primaryMain text-primaryMain">
        <thead>
          <tr>
            <th class="table-header is-vcentered"></th>
            <th data-i18n-key="lightTheme" class="table-header is-vcentered">
              Light Theme
            </th>
            <th data-i18n-key="darkTheme" class="table-header is-vcentered">
              Dark Theme
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-i18n-key="accent" class="is-vcentered text-base">
              Accent
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="accentLight"
                name="accentLight"
                value="#F5B451" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="accentDark"
                name="accentDark"
                value="#F5B451" />
            </td>
          </tr>
          <tr>
            <td class="is-vcentered is-flex is-flex-direction-column">
              <span data-i18n-key="accentSecondary" class="text-base">
                Accent Secondary
              </span>
              <span class="text-xs" data-i18n-key="hoverTableHeader">
                (Hover, Table Header)
              </span>
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="accentSecondaryLight"
                name="accentSecondaryLight"
                value="#FCEDD8" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="accentSecondaryDark"
                name="accentSecondaryDark"
                value="#303030" />
            </td>
          </tr>
          <tr>
            <td class="is-vcentered is-flex is-flex-direction-column">
              <span data-i18n-key="backgroundPrimary" class="text-base">
                Background Primary
              </span>
              <span class="text-xs" data-i18n-key="baseBackground">
                (Base Background)
              </span>
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="backgroundPrimaryLight"
                name="backgroundPrimaryLight"
                value="#FFFFFF" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="backgroundPrimaryDark"
                name="backgroundPrimaryDark"
                value="#222222" />
            </td>
          </tr>
          <tr>
            <td class="is-vcentered is-flex is-flex-direction-column">
              <span data-i18n-key="backgroundSecondary" class="text-base">
                Background Secondary
              </span>
              <span class="text-xs" data-i18n-key="headerFooter">
                (Header, Footer)
              </span>
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="backgroundSecondaryLight"
                name="backgroundSecondaryLight"
                value="#FFFFFF" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="backgroundSecondaryDark"
                name="backgroundSecondaryDark"
                value="#303030" />
            </td>
          </tr>
          <tr>
            <td class="is-vcentered is-flex is-flex-direction-column">
              <span data-i18n-key="textPrimary" class="text-base">
                Text Primary
              </span>
              <span class="text-xs" data-i18n-key="baseText">(Base Text)</span>
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="textPrimaryLight"
                name="textPrimaryLight"
                value="#222222" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="textPrimaryDark"
                name="textPrimaryDark"
                value="#FFFFFF" />
            </td>
          </tr>
          <tr>
            <td data-i18n-key="textSecondary" class="is-vcentered text-base">
              Text Secondary
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="textSecondaryLight"
                name="textSecondaryLight"
                value="#222222" />
            </td>
            <td>
              <input
                class="input"
                type="color"
                id="textSecondaryDark"
                name="textSecondaryDark"
                value="#222222" />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <textarea
      id="variablesSnippet"
      rows="5"
      class="textarea w-full mt-5"></textarea>
    <button
      id="copyVariableSnippetToClipboard"
      class="primary-button is-bordered mt-3"
      data-i18n-key="copyToClipboard">
      Copy to clipboard
    </button>
  </section>
`;

export default CustomThemeTemplate;
